import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-portal-check-circle",
  "use": "rt-portal-check-circle-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"rt-portal-check-circle\">\n<g>\n\t<path d=\"M699,353h-46.9c-10.2,0-19.9,4.9-25.9,13.3L469,584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5,0-10.3,7.4-6.5,12.7\n\t\tl124.6,172.8c12.7,17.7,39,17.7,51.7,0l210.6-292C709.3,360.4,705.5,353,699,353z\" />\n\t<path d=\"M512,64C264.6,64,64,264.6,64,512s200.6,448,448,448s448-200.6,448-448S759.4,64,512,64z M512,884\n\t\tc-205.4,0-372-166.6-372-372s166.6-372,372-372s372,166.6,372,372S717.4,884,512,884z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/check-circle.svg
// module id = 1258
// module chunks = 116